import { useDispatch } from 'react-redux'
import TwoColumnLayout from '../../layouts/two-column-layout/two-column-layout'
import SettingsDetails from './settings-details/settings-details.component'
import SettingsMobileSelection from './settings-mobile-selection/settings-mobile-selection.component'
import SettingsSelection from './settings-selection/settings-selection.component'
import { getUserId } from 'utils/common'
import { useContext, useEffect } from 'react'
import { setUser } from 'store/auth/auth.slice'
import { clearMobileTabIndex, setTabIndex } from 'store/company/company.slice'
import SettingsProvider, {
  SettingsContext,
  SettingsProviderValue,
} from './settings.provider'
import { useGetUserByIdQuery } from 'store/auth/auth.api'

const SettingsPage = () => {
  const dispatch = useDispatch()
  const userId = getUserId()

  const { setUser: setCompany } = useContext(
    SettingsContext
  ) as unknown as SettingsProviderValue

  const { data: user } = useGetUserByIdQuery({ userId }, { skip: !userId })

  useEffect(() => {
    dispatch(setTabIndex({ index: 0 }))
    dispatch(clearMobileTabIndex())
  }, [dispatch])

  useEffect(() => {
    if (user) {
      dispatch(setUser({ user }))
      setCompany(user)
    }
  }, [dispatch, setCompany, user])

  return (
    <SettingsProvider>
      <TwoColumnLayout>
        <SettingsSelection />
        <SettingsDetails />
        <SettingsMobileSelection />
      </TwoColumnLayout>
    </SettingsProvider>
  )
}

export default SettingsPage
